<div class="mx-auto p-2 py-4 w-full">
    <div class="w-full md:flex lg:flex md:justify-end lg:justify-end md:mb-10">
        <span class="text-sm" style="list-style-type: none; text-align: justify">
            Your school’s Suggested Annual Data Target has been identified based on key metrics from the Archdiocese Dashboard page. 
            To help focus in on areas of growth, OCS has prioritized recommended data that highly correlates to school success. 
            Depending on where your school is currently performing, you’ll see one of three goals appear in your Suggested Annual Data Target box - 
            1) Students will have a positive Growth in Reading and Math, 
            2) 50% or higher of students will be at proficient in Math and Reading, or 
            3) All grade levels will meet/exceed Blue Ribbon cut scores. 
            Your Suggested ADT can help you identify where to dedicate time and attention this school year.
        </span>
    </div>
    <div class="tour-step-9">
      <p class="text-base font-bold underline p-1 ">SUGGESTED ANNUAL DATA TARGET</p>
      <input
        class="w-full p-3 rounded shadow-md border text-sm border-gray-300 disabled:bg-indigo-50 text-slate-500 font-normal"
        type="text"
        disabled
        [value]="defaultADT"
        placeholder="N/A"
      />
      <div class="text-right mt-2">
        <button class="tour-step-10 rounded shadow-md bg-[#E31C79] hover:bg-rose-700 text-sm p-2 text-white font-normal" (click)="addInput()">Add ADT</button>
      </div>
    </div>

    <div class="my-2 " *ngIf="inputDataArray.length > 0">
      <p class="text-base font-bold underline p-1">ANNUAL DATA TARGET</p>
      <form class="lg:w-full rounded-lg" [formGroup]="dataForm">
        <div formArrayName="inputDataArray">
          <div class="w-full lg:flex md:flex my-2" *ngFor="let control of inputDataArray.controls; let i = index">
            <textarea
              [formControlName]="i"
              style="overflow: hidden; height: auto;"
              cdkTextareaAutosize
              cdkAutosizeMinRows="1"
              [rows]="rows[i] ? rows[i] : 2"
              class="w-full p-3 rounded-l min-h-12 shadow-md text-sm border border-gray-300 outline-none focus:border-blue-400 font-normal text-slate-500"
              type="text"
              maxlength="65535"
              placeholder="Add your Annual Data Target Here..."
            ></textarea>
            <button
              class="btn btn-primary bg-zinc-600	text-white rounded-r px-3"
              tooltip="Delete Target"
              type="button"
              (click)="removeItem(i)"
            >X</button>
          </div>
        </div>
      </form>
      <div class="text-right mt-2">
        <button class="rounded shadow-md bg-[#E31C79] text-sm p-2 text-white font-normal" (click)="saveData()">Save</button>
      </div>
    </div>
</div>